import { encode } from "uqr";

// A QR code drawn in the page, so the authenticator secret it carries never
// leaves the browser (no image service sees it). Dark modules on a white
// background with the standard four-module margin, whatever the page's theme,
// because that's what phone cameras read most reliably.
export function QrCode({ text, label }: { text: string; label: string }) {
  const { size, data } = encode(text, { ecc: "M", border: 4 });
  let path = "";
  data.forEach((row, y) =>
    row.forEach((dark, x) => {
      if (dark) path += `M${x} ${y}h1v1h-1z`;
    }),
  );
  return (
    <svg
      className="qr"
      role="img"
      aria-label={label}
      viewBox={`0 0 ${size} ${size}`}
      width={size * 5}
      height={size * 5}
      shapeRendering="crispEdges"
    >
      <rect width={size} height={size} fill="#fff" />
      <path d={path} fill="#000" />
    </svg>
  );
}
